<template lang="pug">
div
  //- .bg-login(style="background-image: url(assets/img/login-bg.jpg)" data-id="login-cover-image")
  .bg-login(data-id="login-cover-image")
    .page-container.modal-dialog-centered.mx-auto.my-0(style="max-width: 500px;padding: 0 8px;")
      .login.login-v2.w-100.mx-auto.text-center(data-pageload-addclass='animated fadeIn')
        .login-header
          .brand.text-yellow.text-center.text-uppercase
            h3.text-light.mb-3.animated.fadeInDown {{ $t('message.denied') }}
        .login-content
          h4.mb-3.animated.fadeInDown {{ $t('message.relogin') }}
          .login-buttons
            b-button(to="/login" type="button" size="lg" variant="primary").btn-block.btn-sm
              i.fa.fa-sign-in-alt
              span  {{ $t("ui.login") }}
</template>

<script>
export default {
  components: {},
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.headline {
  font-size: 72px;
  color: #333333;
  text-shadow: -1px -1px 0px rgba(255, 255, 255, 0.3), 1px 1px 0px rgba(0, 0, 0, 0.8);
}
h3 {
  color: #888888;
}
.view-z {
  background: #222;
}
</style>
